export default __webpack_public_path__ + "static/templates-f02817259b7aa43f17b1b722fb893ec7.png";